module.exports = __webpack_public_path__ + "img/scissors.b7cde174.svg";